// eslint-disable-next-line import/no-anonymous-default-export
export default {
  translation: {
    keys: {
      hi: 'Hola',
      all: 'Todo',
      logout: 'Cerrar sesión',
      signin: 'Iniciar sesión',
      continue: 'Continúa',
      recovery_password: 'Recuperar mi contraseña',
      back: 'Atrás',
      created_at: 'Creado en',
      updated_at: 'Actualizado a las',
      no_entries: 'Entradas no encontradas',
      filter: 'Filtrar',
      filters: 'Filtros',
      data: 'Fecha',
      columns: 'Columnas',
      saving: 'Ahorro...',
      loading: 'Cargando...',
      waiting: 'Espera...',
      downloading: 'Descargando ...',
      today: 'hoy dia',
      month: 'mes',
      week: 'semana',
      day: 'día',
      list: 'lista',
      previous: 'anterior',
      next: 'Siguiente',
      details: 'Detalles',
      warnings: 'Advertencias',
      description: 'Descripción',
      unknown: 'Desconocido',
      free_price: 'Gratis',
      paid_price: 'Padre',
      device: 'Dispositivo',
    },

    layout: {
      nav: {
        bots: { title: 'Mis bots' },
        marketplace: { title: 'Mercado' },
        reports: { title: 'Informes' },
        databases: { title: 'Bases de datos' },
        templates: { title: 'Plantillas' },
        ocr: { title: 'OCR' },
        admin: { title: 'Administración' },
        help: { title: 'Ayudar' },
      },
    },

    columns: {
      clean_all: 'Limpiar todos los datos',
      name: 'Nombre',
      agenda_id: 'Identificación del grupo',
      email: 'Correo electrónico',
      confirmation_code: 'Código de confirmación',
      lang: 'Idioma',
      password: 'Contraseña',
      attempts: 'Intentos',
      created_at: 'Creado en',
      created_by: 'Creado por',
      updated_at: 'Actualizado a las',
      status: 'Estado',
      started_at: 'Empezó a las',
      start_at: 'Empieza en',
      title: 'Título',
      failed_reason: 'Razón fallida',
      done_at: 'Donar en',
      reason: 'Razón',
      type: 'Escribe',
      description: 'Descripción',
      template: 'Plantilla',
    },

    messages: {
      invalid_password: 'Contraseña actual inválida. Intentar otra vez',
      invalid_user_password: 'Usuario o contraseña no válidos.',
      invalid_user: 'Usuario invalido. Intentar otra vez',
      invalid_code: 'Código de confirmación inválido. Intentar otra vez',
      unexpected_error: 'Error inesperado. Intentar otra vez.',
    },

    dialogs: {
      default: {
        title: '¡Advertencia!',
        description: '¿Está usted seguro de eso?',
      },
      buttons: {
        cancel: 'No, cancelar',
        confirm: 'Sí, continuar',
      },
      remove: {
        title: '¡Advertencia!',
        description: '¿De verdad quieres eliminar esto?',
      },
    },

    formats: {
      date: 'YYYY/MM/DD',
      datetime: 'YYYY/MM/DD HH:mm',
    },

    actions: {
      save: 'Ahorrar',
      saving: 'Ahorro',
      run: 'Ejecutar trabajo',
      stop: 'Detener',
      cancel: 'Cancelar',
      remove: 'Eliminar',
      make_admin: 'Hacer administrador',
      remove_admin: 'Eliminar administrador',
      remove_entry: 'Elimine la entrada',
      remove_entry_group: 'Eliminar todas las entradas de grupo',
      delete: 'Eliminar',
      search: 'Búsqueda',
      import: 'Importar',
      add: 'Agregar',
      create: 'Crear',
      edit: 'Editar',
      invite: 'Invitación',
      resend: 'Reenviar',
      change: 'Cambio',
      change_password: 'Cambia la contraseña',
      remove_all: 'Eliminar todo',
      add_rule: 'Agregar regla',
      export_csv: 'Exportar a CSV',
      hire: 'Contratar',
      requesting: 'Solicitando',
      rerun: 'Re ejecutar',
    },

    status: {
      pending: 'Pendiente',
      working: 'Laboral',
      failed: 'Fallido',
      canceled: 'Cancelado',
      done: 'Hecho',
      not_done: 'No hecho',
      processing: 'Procesando',
      open: 'Abierto',
      in_progress: 'En proceso',
    },

    authorizer: {
      no_permission: 'No tienes permiso para ver esta página.',
    },

    signin: {
      description: 'Inicie sesión con sus credenciales.',
      code_sent: 'Enviamos un código de confirmación a su correo electrónico.',

      form: {
        email_input: {
          placeholder: 'Escriba su correo electrónico',
        },
        password_input: {
          placeholder: 'Escribe tu contraseña',
        },
        code_input: {
          placeholder: 'Escriba su código de confirmación',
        },
      },
    },

    forget_password: {
      title: '¿Olvidaste tu contraseña?',
      description: '¡Recupera tu cuenta! Ingresa tu correo electrónico y te enviaremos un enlace para que puedas recuperar tu contraseña.',
    },

    profile: {
      title: 'Perfil',
      dialogs: {
        remove_avatar: {
          description: '¿De verdad quieres eliminar tu avatar?',
        },
      },

      messages: {
        success_avatar_removed: '¡Avatar eliminado!',
        success_avatar_changed: '¡Avatar guardado!',
      },

      about_form: {
        title: 'Acerca de mí',
        name_input: {
          label: 'Nombre:',
          placeholder: 'Escriba su nombre',
        },
        email_input: {
          label: 'Email:',
          placeholder: 'Escriba su correo electrónico',
        },
        lang_input: {
          label: 'Idioma:',
          placeholder: 'Elige tu idioma',
        },
      },

      security_form: {
        title: 'Seguridad',
        password_input: {
          label: 'Contraseña actual:',
          placeholder: 'Escriba su contraseña actual',
        },
        new_password_input: {
          label: 'Nueva contraseña:',
          placeholder: 'Escriba su nueva contraseña',
        },
      },
    },

    bots: {
      title: 'Mis bots',
      bots_found: 'robots disponibles',
      no_entries: 'Su empresa aún no tiene ningún bot.',
      no_config: 'La configuración no está disponible para este bot',
      tabs: {
        jobs: 'Trabajos',
        calendar: 'Calendario',
        config: 'Ajustes',
        reports: 'Informes',
      },
      categories: {
        title: 'Departamentos',
        none: 'En el departamento',
      },
      config: {
        about: {
          title: 'DATOS',
        },
        notification: {
          title: 'NOTIFICACIONES',
          form: {
            events: 'Eventos',
          },
        },
        task: {
          title: 'TAREA',
          no_form_message: 'Este bot no requiere ninguna configuración.',
        },
      },
      reports: {
        add: {
          title: 'Nuevo reporte',
          form: {
            name: {
              label: 'Reportar nombre',
            },
            description: {
              label: 'Descripción',
            },
          },
        },
      },
      jobs: {
        disabled: 'Este bot está deshabilitado',
        details: {
          title: 'Detalles del trabajo',
        },
        messages: {
          waiting_device: 'Esperando respuesta del dispositivo...',
        },
        add: {
          title: 'Ejecutar trabajo',
          no_form_message: 'Este bot no requiere ningún parámetro.',
          error_add: 'No crear trabajo. Inténtalo de nuevo.',
        },
        card: {
          pending: 'En fila',
          done: 'Hecho',
          bot_done: 'No hecho',
          failed: 'Fallido',
          total: 'Total',
          working: 'Laboral',
          avg_time: 'Tiempo promedio',
          job_time: 'Tiempo Total',
          columns: {
            request_by: 'Solicitado por',
            created_at: 'Solicitado en',
            started_at: 'Empezó a las',
            done_at: 'Hecho',
          },
        },
        sections: {
          working: {
            title: 'LABORAL',
          },
          last_jobs: {
            title: 'ÚLTIMOS TRABAJOS',
          },
        },
      },
    },

    bot_report: {},

    agenda: {
      actions: {
        repeat: 'Repetir',
      },
      dialogs: {
        remove_item: {
          title: 'Remover el artículo',
          description: `¿Realmente desea eliminar <b> {{title}} </b> en {{date}}?`,
        },

        remove_all: {
          title: 'Remove all items',
          description: `¿Realmente desea eliminar <b class="text-danger">todos</b> elementos?`,
        },
      },

      form: {
        title: {
          label: 'Título de identificación',
        },
        date: {
          label: 'Fecha',
        },
        time: {
          label: 'Hora',
        },
      },
    },

    devices: {
      form: {
        title: {
          label: 'Dispositivo',
        },
      },
    },

    work_objects: {
      title: 'Work objects',
    },

    databases: {
      title: 'Databases',
    },

    ocr: {
      title: 'OCR',
      add: {
        title: 'Agregar plantilla OCR',
      },
    },

    templates: {
      title: 'Templates',
      helps: {
        name: 'El nombre es una identificación única sin caracteres especiales para identificar la plantilla.',
      },
    },

    reports: {
      title: 'Informes',
      require_filter: 'Por favor, complete los filtros del informe para ver los datos.',
    },

    database: {
      not_found: '¡UPS! No pude encontrar la base de datos que busca.',
      actions: {
        import_data: 'Importar conjuntos de datos',
      },
      alerts: {
        remove: {
          title: '¡Tranquilo!',
          text: '¿Realmente quieres eliminar este registro?',
        },
        remove_all: {
          title: '¡Tranquilo!',
          text: '¿Realmente desea eliminar todos los registros de esta base de datos?',
        },
      },
    },

    importer: {
      title: 'Importador de datos',
      actions: {
        download_template: 'Descargar plantilla CSV',
      },
    },

    exporter: {
      title: 'Exportador de datos',
      actions: {
        download_csv: 'Descarga CSV',
        show_downloads: 'Mostrar descargas',
      },
      types: {
        work_objects: 'Objetos de trabajo',
        bot_reports: 'Informes del bot',
        databases: 'Bases de datos',
      },
    },

    admin: {
      members: {
        tab: 'Miembros',
      },
      roles: {
        tab: 'Funciones',
        columns: {
          name: 'Nombre',
        },
        form: {
          name_input: {
            label: 'Nombre:',
            placeholder: 'Escriba el nombre del rol',
          },

          sections: {
            permissions: {
              title: 'Permissions',
            },
          },
        },
      },

      invites: {
        tab: 'Invita',
        title: 'Miembro invitado',
        messages: {
          invite_sent: 'Invitar enviado',
          invite_conflit: 'Ya hay una invitación para este correo electrónico',
        },
        columns: {
          invited_by: 'Invitado por',
          date: 'Fecha',
        },

        form: {
          email_input: {
            label: 'Escriba el correo electrónico del nuevo miembro:',
          },
          role_input: {
            label: 'Seleccione el nuevo rol de miembro:',
          },
        },
      },

      categories: {
        tab: 'Departamentos',
        errors: {
          remove: 'El departamento no se puede eliminar. Por favor, asegúrese de que no haya un bot asociado',
        },
        form: {
          name_input: {
            placeholder: 'Escriba el nuevo nombre del departamento ',
          },
        },
      },
    },

    components: {
      users: {
        role_select: {
          placeholder: 'Agregar roles',
        },
        actions: {
          remove: 'Eliminar miembro',
          make_admin: 'Hacer administrador',
          remove_admin: 'Eliminar administrador',
        },
        confirmations: {
          remove: `¿De verdad quieres eliminar al miembro <b> {{name}} </b> del equipo?`,
          make_admin: '¿Realmente desea que el miembro <b> {{name}} </b> administrador de la empresa?',
          remove_admin: '¿Realmente desea eliminar los privilegios del miembro <b> {{name}} </b> como administrador de la empresa?',
        },
      },
    },

    react_query_builder: {
      larger: '	Mas grande que',
      smaller: 'Menos que',
      larger_equal: 'Mayor qué o igual a',
      smaller_equal: 'Menos que o igual a',
      equal: 'Igual a',
      not_equal: 'No es igual',
      not_in: 'No en',
      between: 'Entre',
      not_between: 'No entre',
      like: 'Contiene',
      not_like: 'No contiene',
      select_value: 'Seleccione su valor',
    },

    pagination: {
      items_per_page: 'Cantidad de artículos por página',
    },
  },
};
